var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_c('pop-prompt', {
    attrs: {
      "isClose": true,
      "isShadowClick": !_vm.isRewardRankGiftShard,
      "className": "pop-login-reward",
      "show": _vm.popLoginRewardShow,
      "content": "html",
      "title": "",
      "isBtnCancel": false,
      "isBtnConfirm": true,
      "confirmText": _vm.isRewardRankGiftShard ? 'Go head' : 'Get'
    },
    on: {
      "close": function ($event) {
        return _vm.doLoginReward('close');
      },
      "update:show": function ($event) {
        _vm.popLoginRewardShow = $event;
      },
      "confirm": function ($event) {
        return _vm.doLoginReward('confirm');
      }
    }
  }, [_vm.isRewardRankGiftShard ? _c('div', {
    staticClass: "popGiftShard"
  }, [_c('div', {
    staticClass: "popGiftShard__title"
  }, [_vm._v("Congratulations")]), _vm.rewards?.information?.reason ? _c('div', {
    staticClass: "popGiftShard__sub"
  }, [_vm._v(_vm._s(_vm.rewards?.information?.reason))]) : _vm._e(), _c('div', {
    staticClass: "popGiftShard-prize"
  }, _vm._l(_vm.filteredRewards, function (value, key, index) {
    return _c('div', {
      staticClass: "popGiftShard-prize-item",
      class: [key == 'giftshard' && 'giftshard', !value && 'empty']
    }, [key == 'coin' ? _c('img', {
      attrs: {
        "src": require(`@images/icon/icon-hic.png`),
        "alt": ""
      }
    }) : key == 'airdrop_ticket' ? _c('img', {
      attrs: {
        "src": require(`@images/icon/icon-pass.png`),
        "alt": ""
      }
    }) : key == 'spins' ? _c('img', {
      attrs: {
        "src": require(`@images/icon/icon-spins.png`),
        "alt": ""
      }
    }) : key == 'stock' ? _c('img', {
      attrs: {
        "src": require(`@images/icon-stock.png`),
        "alt": ""
      }
    }) : _vm._e(), _c('div', {
      staticClass: "popGiftShard-prize-item__label"
    }, [_vm._v("+"), key == 'usdt' ? _c('m-count-up', {
      attrs: {
        "endVal": Number(value),
        "options": {
          decimalPlaces: 3
        }
      }
    }) : _c('m-count-up', {
      attrs: {
        "endVal": Number(value)
      }
    })], 1)]);
  }), 0), _vm.rewards.giftshard ? _c('div', {
    staticClass: "popGiftShard-list"
  }, [_c('div', {
    staticClass: "popGiftShard-list__title"
  }, [_c('span', [_vm._v("Shards " + _vm._s(_vm._f("fmt_pre")(_vm.rewards.giftshard)))])]), _c('div', {
    staticClass: "popGiftShard-scroll"
  }, _vm._l(_vm.rewards.rewards.giftshard, function (val, ke, index) {
    return _c('div', {
      key: `gamereward${index}`,
      staticClass: "popGiftShard-item-chip",
      attrs: {
        "data-index": index <= 50 ? index + 0.2 : 0
      }
    }, [_c('div', {
      staticClass: "popGiftShard-item-chip-icon",
      style: {
        background: `url(${val.image}) center top/auto 100% no-repeat`
      }
    }), _c('div', {
      staticClass: "popGiftShard-item__name"
    }, [_c('span', [_vm._v(_vm._s(val.name))])]), _c('div', {
      staticClass: "popGiftShard-item__num"
    }, [_vm._v("+"), _c('m-count-up', {
      attrs: {
        "endVal": Number(val.amount)
      }
    })], 1)]);
  }), 0)]) : _vm._e()]) : [_c('div', [_vm.rewards && _vm.rewards.information?.activity_image ? _c('img', {
    attrs: {
      "src": _vm.rewards.information?.activity_image,
      "alt": ""
    }
  }) : _c('img', {
    attrs: {
      "src": require('@images/login-sign.jpg'),
      "alt": ""
    }
  })]), _c('div', {
    staticClass: "pop-prize-list"
  }, [_vm.rewards && _vm.rewards.coin > 0 ? _c('div', {
    staticClass: "pop-prize-item"
  }, [_c('img', {
    attrs: {
      "src": require('@images/COIN.png')
    }
  }), _c('div', [_vm._v("+"), _c('m-count-up', {
    attrs: {
      "endVal": _vm.rewards.coin
    }
  })], 1)]) : _vm._e(), _vm.rewards && _vm.rewards.spins > 0 ? _c('div', {
    staticClass: "pop-prize-item"
  }, [_c('img', {
    attrs: {
      "src": require('@images/SPINS.png')
    }
  }), _c('div', [_vm._v("+"), _c('m-count-up', {
    attrs: {
      "endVal": _vm.rewards.spins
    }
  })], 1)]) : _vm._e(), _vm.rewards && _vm.rewards.airdrop_ticket > 0 ? _c('div', {
    staticClass: "pop-prize-item"
  }, [_c('img', {
    attrs: {
      "src": require('@images/PASS.png')
    }
  }), _c('div', [_vm._v("+"), _c('m-count-up', {
    attrs: {
      "endVal": _vm.rewards.airdrop_ticket
    }
  })], 1)]) : _vm._e(), _vm.rewards && _vm.rewards.stock > 0 ? _c('div', {
    staticClass: "pop-prize-item"
  }, [_c('img', {
    attrs: {
      "src": require(`@images/icon-stock.png`),
      "alt": ""
    }
  }), _c('div', [_vm._v("+"), _c('m-count-up', {
    attrs: {
      "endVal": _vm.rewards.stock
    }
  })], 1)]) : _vm._e(), _vm.rewards && _vm.rewards.giftshard > 0 ? _c('div', {
    staticClass: "pop-prize-item"
  }, [_c('img', {
    attrs: {
      "src": require(`@images/icon/icon-giftshare.png`),
      "alt": ""
    }
  }), _c('div', [_vm._v("+"), _c('m-count-up', {
    attrs: {
      "endVal": _vm.rewards.giftshard
    }
  })], 1)]) : _vm._e()])]], 2)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };